
import { reactive, defineComponent, onMounted, watch } from "vue";
import ApiReceita from "@/api/apiReceita";
import { Ingrediente } from "@/api/interfacesReceita";
import FormIngrediente from "@/components/ingredientes/FormIngrediente.vue";
import ContainerIngrediente from "@/components/ingredientes/ContainerIngrediente.vue";

export default defineComponent({
  components: { ContainerIngrediente, FormIngrediente },
  name: "Ingrediente",
  setup() {
    interface State {
      ingredientes: Array<Ingrediente>;
      ingrediente: string;
      item?: number;
      erro: string;
      cadastro: boolean;
      load: boolean;
    }
    const state = reactive({
      ingredientes: [] as Array<Ingrediente>,
      ingrediente: "",
      item: undefined,
      erro: "",
      cadastro: false,
      load: false
    }) as State;

    async function retornaIngredientes() {
      state.load = true;
      const request = new ApiReceita();
      await request
        .getIngrediente()
        .then(response => {
          state.ingredientes = response;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          state.load = false;
        });
    }

    function filtraIgrediente() {
      if (state.ingrediente.length >= 3) {
        const filtroIngrediente = state.ingredientes.filter(nome => {
          return (
            nome.descricao
              .toLowerCase()
              .indexOf(state.ingrediente.toLowerCase()) > -1
          );
        });
        if (Object.keys(filtroIngrediente).length === 0) {
          state.erro =
            "Não encontramos esse ingrediente. Tente buscar novamente.";
        } else {
          state.ingredientes = filtroIngrediente;
        }
      } else if (state.ingrediente.length == 0) {
        state.erro = "";
        retornaIngredientes();
      }
    }

    function showCadastro() {
      state.item = undefined;
      state.cadastro = !state.cadastro;
    }

    function Recarregar(resp: boolean) {
      if (resp) retornaIngredientes();
    }

    function Update(item: Ingrediente) {
      state.item = item.id;
      state.cadastro = true;
    }

    onMounted(() => {
      retornaIngredientes();
    });

    watch(
      () => state.ingrediente,
      () => {
        filtraIgrediente();
      }
    );
    return { state, filtraIgrediente, showCadastro, Recarregar, Update };
  }
});
